import axios from 'axios';

const api = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export const setupAxiosInterceptors = (handleSessionExpiry) => {
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        error.response &&
        (error.response.status === 401)
      ) {
        localStorage.removeItem('token');
        localStorage.removeItem('authUser');
        localStorage.removeItem('authUserId');
        localStorage.removeItem('userRole');
        localStorage.removeItem('email');
        localStorage.removeItem('role');
        localStorage.removeItem('selected_student');
        localStorage.removeItem('student_selected');
        localStorage.removeItem('primary_mail_id');
        localStorage.removeItem('activeTab');
        localStorage.removeItem("paymentResponse");
        localStorage.removeItem("selectedStudent");
    

        handleSessionExpiry();
      }
      return Promise.reject(error);
    }
  );
};

export async function get(url, options = {}) {
  return api.get(url, options).then((res) => res);
}

export async function post(url, data) {
  return api.post(url, data).then((res) => res);
}

export async function post2(url, data) {
  const headers = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  return api.post(url, data, headers).then((res) => res);
}

export async function put(url, data) {
  return api.put(url, data).then((res) => res);
}

export async function put2(url, data) {
  const headers = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  return api.put(url, data, headers).then((res) => res);
}

export async function del(url, data) {
  return api.delete(url, { data }).then((res) => res);
}

export default api;